import { render, staticRenderFns } from "./CardAttractionSearch.vue?vue&type=template&id=620686b2&scoped=true"
import script from "./CardAttractionSearch.vue?vue&type=script&lang=js"
export * from "./CardAttractionSearch.vue?vue&type=script&lang=js"
import style0 from "./CardAttractionSearch.vue?vue&type=style&index=0&id=620686b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620686b2",
  null
  
)

export default component.exports